import { render } from "./index.vue?vue&type=template&id=1610d852"
const script = {}

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__